import {
  apiRequestGet,
  apiRequestPost,
  apiRequestPatch,
  apiRequestDelete,
} from 'mastodon/api';

import type {
  ApiAudienceListJSON,
  ApiCreateAudienceListPayload,
  ApiUpdateAudienceListPayload,
  ApiAudienceListMemberJSON,
} from '../api_types/audience_lists';

export const apiGetAudienceLists = () =>
  apiRequestGet<ApiAudienceListJSON[]>('v1/audience_lists');

export const apiGetAudienceList = (id: string) =>
  apiRequestGet<ApiAudienceListJSON>(`v1/audience_lists/${id}`);

export const apiCreateAudienceList = (payload: ApiCreateAudienceListPayload) =>
  apiRequestPost<ApiAudienceListJSON>('v1/audience_lists', payload);

export const apiUpdateAudienceList = ({
  id,
  ...payload
}: ApiUpdateAudienceListPayload) =>
  apiRequestPatch<ApiAudienceListJSON>(`v1/audience_lists/${id}`, payload);

export const apiDeleteAudienceList = (id: string) =>
  apiRequestDelete(`v1/audience_lists/${id}`);

export const apiGetAudienceListMembers = (
  id: string,
  params?: { max_id?: string; limit?: number },
) =>
  apiRequestGet<ApiAudienceListMemberJSON[]>(
    `v1/audience_lists/${id}/members`,
    params,
  );

export const apiAddAudienceListMember = (id: string, accountId: string) =>
  apiRequestPost<ApiAudienceListMemberJSON>(`v1/audience_lists/${id}/members`, {
    account_id: accountId,
  });

export const apiRemoveAudienceListMember = (id: string, accountId: string) =>
  apiRequestDelete(`v1/audience_lists/${id}/members/${accountId}`);
